var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-rectangle card-component relative",class:{ active: _vm.isSelected },on:{"click":_vm.handleClick}},[_c('div',{staticClass:"absolute gradient-bg"}),_vm._v(" "),_c('p',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }